module.exports = __webpack_public_path__ + "media/images/item/btn_clap-493f7a265da9e9e44a77f4919fc8bfd3.png";